import type { WorkspaceDoc } from '@/lib/sync/entity-types';
import { getEntityKindMeta } from '@/utils/entity-kind-meta';

export function displayTitle(doc: Pick<WorkspaceDoc, 'title'>): string {
  return doc.title || 'Untitled';
}

export function kindIcon(kind: string): string {
  // Delegates to the single source of truth for entity-kind icons; unknown
  // kinds fall back to the `document` icon (`description`).
  return getEntityKindMeta(kind).icon;
}
